import { FC } from "react";
import {
  creditCardSVG,
  dollarSVG,
  masterCardSVG,
} from "../../../../../assets/SVGs/SVGs";
import ModalHeading from "../ModalHeading";
import { Form, Input } from "antd";
import { useIntl } from "react-intl";

interface PaymentGatewayProps {
  paymentDetails: {
    cardNumber: string;
    name: string;
    cvv: string;
    expiry: string;
  };
  setPaymentDetails: React.Dispatch<
    React.SetStateAction<{
      cardNumber: string;
      name: string;
      cvv: string;
      expiry: string;
    }>
  >;
}

const PaymentGateway: FC<PaymentGatewayProps> = ({
  paymentDetails,
  setPaymentDetails,
}) => {
  const handleChange = (name: string, value: string) => {
    setPaymentDetails({
      ...paymentDetails,
      [name]: value,
    });
  };
  const intl = useIntl();
  return (
    <div className="space-y-4 p-4 w-full">
      <div className="flex justify-between gap-2 items-center p-4  bg-[#EEF0FF]  rounded ">
        <div>
          <p className="text-[#479821]">{intl.formatMessage({ id: "free" })}</p>
          <p className="text-color-sec-title text-sm">
            {intl.formatMessage({ id: "no_monthly_subscription" })}
          </p>
        </div>
        <div className="flex items-center">{dollarSVG}</div>
      </div>
      <ModalHeading
        title={intl.formatMessage({ id: "invoice_details_title" })}
        description={intl.formatMessage({ id: "invoice_details_description" })}
      />

      <div className="  max-w-[500px] mx-auto bg-[#FBFBFF] p-2 rounded">
        <Form layout="vertical">
          <Form.Item
            colon={false}
            required={false}
            label={intl.formatMessage({ id: "card_number_label" })}
            name="cardNumber"
            rules={[
              {
                required: true,
                message: intl.formatMessage({ id: "card_number_required" }),
              },
            ]}
          >
            <Input
              className=" p-1 h-10"
              onKeyDown={(e) => {
                if (
                  /[^0-9]/.test(e.key) &&
                  !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(
                    e.key
                  )
                ) {
                  e.preventDefault();
                }
              }}
              value={paymentDetails.cardNumber}
              onChange={(e) => handleChange("cardNumber", e.target.value)}
              placeholder={`5261   4141   0151   8472`}
              maxLength={16}
              prefix={
                <>
                  {creditCardSVG}
                  {masterCardSVG}
                </>
              }
            />
          </Form.Item>
          <Form.Item
            colon={false}
            required={false}
            label={intl.formatMessage({ id: "card_holder_name_label" })}
            name="name"
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "card_holder_name_required",
                }),
              },
            ]}
          >
            <Input
              className=" p-1 h-10"
              value={paymentDetails.cardNumber}
              onChange={(e) => handleChange("name", e.target.value)}
              placeholder={`Nour Mohamed`}
            />
          </Form.Item>
          <div className="flex justify-between gap-3">
            <Form.Item
              className="w-full"
              colon={false}
              required={false}
              label={intl.formatMessage({ id: "cvv_label" })}
              name="cvv"
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({ id: "cvv_required_message" }),
                },
                {
                  min: 3,
                  max: 3,
                  message: intl.formatMessage({ id: "cvv_length_message" }),
                },
              ]}
            >
              <Input
                className=" p-1 h-10"
                onKeyDown={(e) => {
                  if (
                    /[^0-9]/.test(e.key) &&
                    ![
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                    ].includes(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
                value={paymentDetails.cvv}
                onChange={(e) => handleChange("cvv", e.target.value)}
                placeholder={`999`}
                maxLength={3}
              />
            </Form.Item>
            <Form.Item
              className="w-full"
              colon={false}
              required={false}
              label={intl.formatMessage({ id: "expiry_label" })}
              name="expiry"
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: "expiry_required_message",
                  }),
                },
                {
                  min: 5,
                  max: 5,
                  message: intl.formatMessage({ id: "expiry_length_message" }),
                },
              ]}
            >
              <Input
                className=" p-1 h-10"
                onKeyDown={(e) => {
                  if (
                    /[^0-9]/.test(e.key) &&
                    ![
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "/",
                    ].includes(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
                value={paymentDetails.expiry}
                onChange={(e) => handleChange("expiry", e.target.value)}
                placeholder={`07/25`}
                maxLength={5}
              />
            </Form.Item>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default PaymentGateway;
